import { render, staticRenderFns } from "./power.vue?vue&type=template&id=64c9ecd8&scoped=true&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9ecd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c9ecd8')) {
      api.createRecord('64c9ecd8', component.options)
    } else {
      api.reload('64c9ecd8', component.options)
    }
    module.hot.accept("./power.vue?vue&type=template&id=64c9ecd8&scoped=true&", function () {
      api.rerender('64c9ecd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolePage/staff/comp/power.vue"
export default component.exports